import { init as init$1, setTag, getDefaultIntegrations as getDefaultIntegrations$1, browserTracingIntegration } from '@sentry/browser';
import { applySdkMetadata, hasTracingEnabled } from '@sentry/core';

// Treeshakable guard to remove all code related to tracing

/**
 * Initialize the client side of the Sentry Astro SDK.
 *
 * @param options Configuration options for the SDK.
 */
function init(options) {
  const opts = {
    defaultIntegrations: getDefaultIntegrations(options),
    ...options,
  };

  applySdkMetadata(opts, 'astro', ['astro', 'browser']);

  init$1(opts);

  setTag('runtime', 'browser');
}

function getDefaultIntegrations(options) {
  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false",
  // in which case everything inside will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      return [...getDefaultIntegrations$1(options), browserTracingIntegration()];
    }
  }

  return undefined;
}

export { init };
//# sourceMappingURL=sdk.js.map
